import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateWithoutTime } from 'components/global/utils';
import { RedatedParams } from '@api/order-reporting/types/RedatedParams';
import { RedatedOrdersReport } from '@api/order-reporting/types/RedatedOrdersReport';
import { RedatedGridData } from '@pages/reporting-pages/redated-orders/types/RedatedGridData';
import { convertToGridData } from '@pages/reporting-pages/redated-orders/store/convertors';
import { DateRange } from '@project-types/DateRange';



interface ReportingRedatedState {
	gridData: RedatedGridData[] | null,
	dateRange: DateRange | null,
	selectedPlant: string | null,
	filterDate: string | null,
};

const initialState: ReportingRedatedState = {
	gridData: null,
	dateRange: null,
	selectedPlant: null,
	filterDate: null,
};



export const reportingRedatedSlice = createSlice({
	name: 'reportingRedated',
	initialState,
	reducers: {
		createGridData: (state, action: PayloadAction<RedatedOrdersReport[] | undefined | null>) => {
			state.gridData = convertToGridData(action.payload);
		},
		setDateRange: (state, action: PayloadAction<DateRange>) => {
			state.dateRange = action.payload;
		},
		setSelectedPlant: (state, action: PayloadAction<string | null>) => {
			state.selectedPlant = action.payload;
		},
		setFilterDate: (state, action: PayloadAction<string | null>) => {
			state.filterDate = action.payload;
		},
		setSearchParameters: (state, action: PayloadAction<RedatedParams>) => {
			let stateFrom = state.dateRange ? state.dateRange.from : null;
			let paramFrom = action.payload.dateFrom ? getDateWithoutTime(action.payload.dateFrom) : null;
			let stateTo = state.dateRange ? state.dateRange.to : null;
			let paramTo = action.payload.dateTo ? getDateWithoutTime(action.payload.dateTo) : null;
			if (stateFrom !== paramFrom || stateTo !== paramTo) {
				state.dateRange = paramFrom && paramTo ? { from: paramFrom, to: paramTo } : null;
			}
			if (action.payload.dc !== state.selectedPlant) {
				state.selectedPlant = action.payload.dc ? action.payload.dc : null;
			}
			if (action.payload.filterDate !== state.filterDate) {
				state.filterDate = action.payload.filterDate ? action.payload.filterDate : null;
			}
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createGridData,
	setDateRange,
	setSelectedPlant,
	setFilterDate,
	setSearchParameters,
	resetStore } = reportingRedatedSlice.actions;